<script setup lang="ts">
import type { Block } from '../../models/index.ts'
import { StrapiBlocks } from 'vue-strapi-blocks-renderer'
import AnimateText from '@/components/AnimateText.vue'
import LocalisedLink from '@/components/LocalisedLink.vue'

const props = defineProps<{
  blockData: Block
  isHeaderBlock: boolean
}>()

const backgroundImageList = props.blockData.media ?? []
const media = backgroundImageList[0]
</script>

<template>
  <div
    v-if="blockData.style == 'site-header'"
    class="grid overflow-hidden sm:h-[65vh] min-h-128 font-alexandria"
  >
    <!-- Backgrounds -->
    <video
      v-if="media && media.mime.includes('video')"
      :src="media.url"
      autoplay
      muted
      loop
      class="col-start-1 row-start-1 z-0 w-full h-full object-cover"
    />
    <img
      v-else-if="media && media.mime.includes('image')"
      :src="media.url"
      alt=""
      class="col-start-1 row-start-1 z-0 w-full h-full object-cover"
    />

    <!-- Darkness overlay -->
    <div v-if="media" class="col-start-1 row-start-1 z-[5] bg-black/50 pointer-events-none"></div>

    <!-- Block content -->
    <div class="col-start-1 row-start-1 z-10">
      <div
        class="flex flex-col sm:h-[65vh] max-w-[1512px] w-full min-h-128 justify-end mx-auto sm:px-24 sm:pb-24 max-sm:px-12 max-sm:pb-12"
      >
        <div class="flex flex-col">
          <AnimateText
            class="sm:text-6xl max-sm:text-4xl font-bold uppercase"
            :text="blockData.title"
          />
          <p
            class="pt-4 sm:text-2xl max-sm:text-xl text-white font-light max-w-96"
            v-html="blockData.header"
          ></p>
        </div>
        <StrapiBlocks v-if="blockData.description" :content="blockData.description" />
        <div class="flex flex-row w-full">
          <LocalisedLink
            v-for="link of blockData.links"
            :key="link.url"
            :to="link.url"
            class="mr-2 flex"
          >
            <div class="cursor-pointer px-3 py-1 bg-purple text-white shadow-lg/50">
              <p class="lowercase text-shadow-lg/59 font-light [font-variant:small-caps]">
                {{ link.title }}
              </p>
            </div>
            <!-- TODO: Case where URL is an external link -->
          </LocalisedLink>
        </div>
      </div>
    </div>
  </div>
</template>
